import React from "react"
import Title from "../Title"
import contact from '../../assets/contact.svg'
import ContactForm from './contactForm'

import { Wrap,Center, Details, Thumbnail} from "./style"

const Contact = () => {
  return (
    <Wrap>
      <Title title={"Contact"} />
      <Center>
        <Thumbnail>
          <img
            src={contact}
            alt="I’m Fred and I’m a FullStack Software Engineer!"
          />
        </Thumbnail>
        <Details>
          <ContactForm />
        </Details>
      </Center>
    </Wrap>
  )
}

export default Contact
